import { qsa } from '@fluorescent/dom';

import { section } from '@/glow';
import Disclosure from '@/lib/disclosure';

const selectors = {
  disclosure: '[data-disclosure]',
};

section('footer', {
  crossBorder: {},
  onLoad() {
    // Wire up Cross Border disclosures
    const cbSelectors = qsa(selectors.disclosure, this.container);

    if (cbSelectors) {
      cbSelectors.forEach(selector => {
        const { disclosure: d } = selector.dataset;
        this.crossBorder[d] = Disclosure(selector);
      });
    }
  },

  onUnload() {
    Object.keys(this.crossBorder).forEach(t => this.crossBorder[t].unload());
  },
});
